import { Grid } from "@material-ui/core";
import { get } from "lodash";
import React from "react";

const DetailsGrid = ({ data, columns, ...restProps }) => {
  return (
    <Grid spacing={3} container {...restProps}>
      {columns.map(
        ({ label, field, valueFormatter = (value) => value, valueGetter }) => {
          const value = valueGetter ? valueGetter(data) : get(data, field);

          return (
            value && (
              <Grid key={field} xs={12} sm={6} item>
                {label && <div className="qd-data-cell-label">{label}</div>}
                <div>{valueFormatter(value)}</div>
              </Grid>
            )
          );
        }
      )}
    </Grid>
  );
};

export default DetailsGrid;
